// Derived from https://www.irs.gov/businesses/corporations/list-of-jurisdictions-that-do-not-issue-foreign-tins
const COUNTRY_CODES_WHICH_DO_NOT_ISSUE_FTIN = [
  "AU", // Australia
  "BM", // Bermuda
  "VG", // British Virgin Islands
  "KY", // Cayman Islands
  "JP", // Japan
];

export default COUNTRY_CODES_WHICH_DO_NOT_ISSUE_FTIN;
